var map = {
	"./pages/batch/batch.module": [
		"./src/app/pages/batch/batch.module.ts",
		"pages-batch-batch-module"
	],
	"./pages/certificates/certificates.module": [
		"./src/app/pages/certificates/certificates.module.ts",
		"pages-certificates-certificates-module"
	],
	"./pages/countries/countries.module": [
		"./src/app/pages/countries/countries.module.ts",
		"pages-countries-countries-module"
	],
	"./pages/fonts/font.module": [
		"./src/app/pages/fonts/font.module.ts",
		"pages-fonts-font-module"
	],
	"./pages/generate-certificate/generate-certificate.module": [
		"./src/app/pages/generate-certificate/generate-certificate.module.ts",
		"pages-generate-certificate-generate-certificate-module"
	],
	"./pages/schools/schools.module": [
		"./src/app/pages/schools/schools.module.ts",
		"pages-schools-schools-module"
	],
	"./pages/users/users.module": [
		"./src/app/pages/users/users.module.ts",
		"pages-users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;